import { RestClient } from '../lib/RestClient'

class ProdutoService extends RestClient {
  constructor() {
    super('produto')
  }

  async filterLanche(params = {}) {
    const response = await this.request.get('/filtrar/lanche', { params })
    return response.data
  }
}

export const Produto = new ProdutoService()
